import React, { useState, useEffect, useRef } from "react";
import { Grid, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { DatePickerInput } from "rc-datepicker";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import { Link } from "react-router-dom";
import BiztranControls from "../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../biztran_controls_formik/BiztranControlsFormik";
import Modal_Frame from "../biztran_controls/Modal_Frame";
import Moment from "moment";
import UseFetchData from "../../hooks/UseFetchData";


const AddMultipleSerialNo = (props) => {

    const [MfgBatchSerialNoID, setMfgBatchSerialNoID] = useState('');
    const [MfgBatchID, setMfgBatchID] = useState('');
    const [SerialNumber, setSerialNumber] = useState('');
    const [FromSerialNumber, setFromSerialNumber] = useState('');
    const [ToSerialNumber, setToSerialNumber] = useState('');
    const [isOpen, setOpen] = useState(false);
    const [isOpenMultiple, setOpenMultiple] = useState(false);
    const [response, fetchData] = UseFetchData();
    const [response1, fetchData1] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData('');
    const [Mode, setMode] = useState('');

    const onSubmit = values => {
        debugger;
        // setMode('Insert');

        var bodyFormData = new FormData();
        bodyFormData.append("MfgBatchID", props.MfgBatchID);
        bodyFormData.append("MfgBatchSerialNoID", props.MfgBatchSerialNoID);
        bodyFormData.append("SerialNumber", values.SerialNumber);
        bodyFormData.append("FromSerialNumber", values.FromSerialNumber);
        bodyFormData.append("ToSerialNumber", values.ToSerialNumber);
        fetchData("MfgBatch/SaveMultipleSerial", bodyFormData);
    }
    const onDelete = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("FromSerialNumber", FromSerialNumber);
        bodyFormData.append("ToSerialNumber", ToSerialNumber);
        fetchData1("MfgBatch/DeleteMultipleSerialNo", bodyFormData);
    }

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("MfgBatchID", props.MfgBatchID);
        bodyFormData.append("MfgBatchSerialNoID", props.MfgBatchSerialNoID);
        bodyFormData.append("SerialNumber", SerialNumber);
        bodyFormData.append("FromSerialNumber", FromSerialNumber);
        bodyFormData.append("ToSerialNumber", ToSerialNumber);
        // bodyFormData.append("MfgDate", MfgDate);
        fetchGetData("MfgBatch/GetByIDSerialNo", bodyFormData);
    }
    useEffect(() => {

        if (responseGetData.length > 0) {
            setMfgBatchID(responseGetData[0].MfgBatchID);
            setMfgBatchSerialNoID(responseGetData[0].MfgBatchSerialNoID);
            setSerialNumber(responseGetData[0].SerialNumber);
            setFromSerialNumber(responseGetData[0].FromSerialNumber);
            setToSerialNumber(responseGetData[0].ToSerialNumber);
            // setIsActive(responseGetData[0].IsActive);
        }
    }, [responseGetData])

    useEffect(() => {
        debugger;
        console.log(props.MfgBatchID)
        if (props.MfgBatchSerialNoID !== '') {
            setMode('Update');
            getByIDData();
        }
        else {
            setMode('Insert');
        }

    }, [])

    var a = FromSerialNumber;
    var c = ToSerialNumber;


    // const openModal = (row) => {
    //     setOpen(true);
    //     setMfgBatchSerialNoID(row.id);
    // };

    // const PopulateData = () => {
    //     var bodyFormData = new FormData();
    //     bodyFormData.append("SerialNumber", SerialNumber);
    //     fetchData2("Model/Seriallist", bodyFormData);
    // }

    // useEffect(() => {
    //     debugger;
    //     if (response1.Response === true) {
    //         props.setOpen(false);
    //         props.PopulateMData();
    //         alert('Saved Succesfully.')
    //     }
    //     else if (response1.Response === false) {
    //         alert('Save Failed.')
    //     }
    // }, [response1])



    useEffect(() => {
        if (response.Response === true) {
            // alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateMData();
        }
        else if (response.Response === false) {
            if (response.Message.includes('Already') === true) {
                alert(response.Message);
            }
            else {
                alert('Failed.');
            }
        }
        // if (props.MfgBatchSerialNoID !== '') {
        //     setMode('Update');
        // }
        // else {
        //     setMode('Insert');
        // }
        if (response.length > 0 && Mode === 'Update') {
            setMfgBatchSerialNoID(response[0].props.MfgBatchSerialNoID);
            setMfgBatchID(response[0].props.MfgBatchID);
            setSerialNumber(response[0].SerialNumber);
            setFromSerialNumber(responseGetData[0].FromSerialNumber);
            setToSerialNumber(responseGetData[0].ToSerialNumber);
        }
    }, [response]);

    useEffect(() => {
        if (response1.Response === true) {
            alert('Data Deleted Succesfully.');
            props.setOpen(false);
            props.PopulateMData();
        }
    }, [response1]);

    // useEffect(() => {
    //     PopulateData();
    // }, [])

    return (
        <div>
            <Formik initialValues={{
                MfgBatchSerialNoID: MfgBatchSerialNoID, MfgBatchID: MfgBatchID, SerialNumber: SerialNumber, FromSerialNumber: FromSerialNumber, ToSerialNumber: ToSerialNumber
            }}
                onSubmit={onSubmit}
                enableReinitialize>
                {formik => {
                    return (<Form>
                        <Grid spacing={2} container>
                            <Grid item xs={12} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='From Serial Number'
                                    name='FromSerialNumber'
                                    values={FromSerialNumber}
                                    onChange={(e) => setFromSerialNumber(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='To Serial Number'
                                    name='ToSerialNumber'
                                    values={ToSerialNumber}
                                    onChange={(e) => setToSerialNumber(e.target.value)}
                                />
                            </Grid>
                            {/* <Grid item xs={12} >

                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Serial Number'
                                    name='SerialNumber'
                                    values={SerialNumber}
                                    onChange={(e) => setSerialNumber(e.target.value)}
                                />
                            </Grid> */}

                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>

                                        {/* <BiztranControls.Button
                                            text="GENERATE"
                                            // type="submit"
                                            startIcon={<SaveIcon />}
                                        /> */}
                                        <BiztranControls.Button
                                            text="UPDATE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="DELETE"
                                            //type="submit"
                                            onClick={() => { onDelete(); }}
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />

                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>)
                }}

            </Formik>

        </div>
    )

}

export default AddMultipleSerialNo;